<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ $route.params.userId === "new" ? "Add new" : activeUser.name | t }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab
                v-for="item in tabs"
                :key="item"
                style="text-transform: none !important;"
                v-if="
                    item !== 'Custom links' ||
                        (item === 'Custom links' && user.id === activeUser.id) ||
                        user.role === 'superadmin'
                "
            >
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <profile-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <custom-links-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import ProfileEditTab from "./user-tab-items/profile-edit-tab.vue";
import CustomLinksEditTab from "./user-tab-items/custom-links-edit-tab";

import Store from "../../store";

export default {
    name: "product-edit",
    components: { ProfileEditTab, CustomLinksEditTab },

    data() {
        return {
            tab: 0,
            tabs: ["Profile", "Custom links"]
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.userId === "new") {
            Store.commit("UserStore/addNewUser");
        } else {
            Store.dispatch("UserStore/getUserData", this.$route.params.userId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("UserStore", ["activeUser", "loadingUserData", "errorMessage", "requestSuccess"]),
        ...mapState(["user"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true) {
                this.$router.push({
                    name: "user-list"
                });
            }
        }
    },
    methods: {
        closeDrawer() {
            this.$router.push({ name: "user-list" });
        },
        submitEdit() {
            Store.dispatch("UserStore/submitUserUpdate", this.activeUser);
            if (this.activeUser.custom_links) {
                Store.commit("setUserCustomLinksData", this.activeUser.custom_links);
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
